import React from 'react';
import { Shield, Zap, EyeOff } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function NEAMethod() {
  return <section className="py-24 md:py-32 bg-teal text-white relative overflow-hidden" data-id="element-297">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-298">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full border border-white/20" data-id="element-299"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full border border-white/30" data-id="element-300"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full border border-white/40" data-id="element-301"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 max-w-5xl relative z-10" data-id="element-302">
        <div className="text-center mb-16" data-id="element-303">
          <FadeIn data-id="element-304">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/10 text-amber mb-6 backdrop-blur-sm border border-white/20" data-id="element-305">
              <Shield size={32} data-id="element-306" />
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-307">
            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6" data-id="element-308">
              El Método de Resiliencia Activa (N.E.A.)
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-309">
            <p className="text-xl md:text-2xl text-teal-100 max-w-3xl mx-auto leading-relaxed" data-id="element-310">
              En lugar de intentar cambiar al acosador, cambiamos el
              "combustible" que recibe.
            </p>
          </FadeIn>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-16" data-id="element-311">
          <FadeIn delay={0.3} data-id="element-312">
            <div className="bg-teal-dark/50 p-8 rounded-2xl border border-teal-light/30 backdrop-blur-sm h-full" data-id="element-313">
              <div className="w-12 h-12 rounded-full bg-amber/20 flex items-center justify-center text-amber mb-6" data-id="element-314">
                <EyeOff size={24} data-id="element-315" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-316">Objetivo Aburrido</h3>
              <p className="text-teal-100 leading-relaxed" data-id="element-317">
                Este sistema enseña a tu hijo a volverse un "objetivo aburrido"
                mediante respuestas de estatus neutro.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-318">
            <div className="bg-teal-dark/50 p-8 rounded-2xl border border-teal-light/30 backdrop-blur-sm h-full" data-id="element-319">
              <div className="w-12 h-12 rounded-full bg-amber/20 flex items-center justify-center text-amber mb-6" data-id="element-320">
                <Zap size={24} data-id="element-321" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-322">Lenguaje de Poder</h3>
              <p className="text-teal-100 leading-relaxed" data-id="element-323">
                Entrenamiento en lenguaje corporal de poder que proyecta
                seguridad sin necesidad de confrontación física.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-324">
            <div className="bg-teal-dark/50 p-8 rounded-2xl border border-teal-light/30 backdrop-blur-sm h-full" data-id="element-325">
              <div className="w-12 h-12 rounded-full bg-amber/20 flex items-center justify-center text-amber mb-6" data-id="element-326">
                <Shield size={24} data-id="element-327" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-328">Neutralización Total</h3>
              <p className="text-teal-100 leading-relaxed" data-id="element-329">
                Cuando el acosador no obtiene lágrimas, miedo ni rabia, busca
                otra víctima. El ciclo se rompe.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}